/**
 * Extract error data from API error response.
 * @param {Error} error - Error object from API call
 * @returns {Object} Error data object with code, message, and status
 */
export const extractErrorData = (error) => {
  const { code, message } = error;
  return {
    code: error.response?.data?.error?.code || code || 'UNKNOWN_ERROR',
    message: error.response?.data?.error?.message || message || 'Unknown error',
    status: error.response?.status || null,
  };
};

/**
 * Map error codes to translation keys for Viaja Ahorrando errors.
 * @param {string} errorCode - Error code from API (VV001, VV002, VV003, etc.)
 * @returns {string} Translation key for the error message
 */
export const getViajaAhorrandoErrorKey = (errorCode) => {
  const errorMap = {
    VV001: 'viaja_ahorrando_reservation_not_found',
    VV002: 'viaja_ahorrando_reservation_expired',
    VV003: 'viaja_ahorrando_promotion_used',
  };

  return errorMap[errorCode] || 'viaja_ahorrando_discounts_error';
};

/**
 * Check if error code requires removing viva_pnr from URL.
 * @param {string} errorCode - Error code from API
 * @returns {boolean} True if viva_pnr should be removed from URL
 */
export const shouldRemoveVivaPnrFromUrl = (errorCode) => {
  // Remove viva_pnr for NotFound (VV001), Expired (VV002), and Used (VV003) errors
  return ['VV001', 'VV002', 'VV003'].includes(errorCode);
};

/**
 * Remove viva_pnr query parameter from current URL.
 */
export const removeVivaPnrFromUrl = () => {
  if (typeof window === 'undefined') return;

  const url = new URL(window.location);
  url.searchParams.delete('viva_pnr');
  window.history.replaceState({}, '', url.toString());
};
